import { Component, Input, ViewChild } from '@angular/core'
import { MenuItem } from 'primeng/api'
import { OverlayPanel } from 'primeng/overlaypanel'

@Component({
  selector: 'app-sticky-header',
  templateUrl: './app-sticky-header.component.html',
  styleUrl: './app-sticky-header.component.scss',
  standalone: false
})
export class AppStickyHeaderComponent {
  @Input() logoUrl: string = ''
  items: MenuItem[] = [ {
    label: 'About Us',
    routerLink: '/about',
    command: () => {
      this.menu.hide()
    }
  }]
  @ViewChild('mobilemenu') menu: OverlayPanel

  
  onStoreClicked() {
    window.open('https://saraplus.myspreadshop.com/', '_blank')
    this.menu.hide()
  }

  onSignupClicked() {
    window.open('https://www.saraplus.com/signup', '_blank')
  }

  onLoginClicked() {
    window.open('https://www.saraplus.com/e/servicepages/login.aspx', '_blank')
    this.menu.hide()
  }
}
